<template lang="pug">
    v-slider(
        v-model="val"
        :min="config.min"
        :max="config.max"
        :step="config.step"
        thumb-label="always"
        ticks="always"
        :tick-size="config.tickSize"
        :tick-labels="config.tickLabels"
        :color="color"
        :thumb-color="color"
        :thumb-size="config.thumbSize"
        @change="handleChange()"
        :readonly="readonly"
    )
        template(v-slot:thumb-label="{ value }")
            | {{ getThumbLabelText(value) }}

</template>

<script lang="ts">
    import Vue from 'vue';
    import { 
        getScorecardItemConfig, 
        getThumbLabel, 
        convertAnswerToSliderValue, 
        convertSliderValueToAnswer, 
        getScorecardItemColor,
        ScorecardItemType
    } from '@/helpers/scorecard_items';

    export default Vue.extend({
        data() {
            return {
                val: null as number | null,
            }
        },
        methods: {
            handleChange() {
                this.$emit('change', this.answerString);
            },
            getThumbLabelText(value: number): string {
                return getThumbLabel(this.type, value);
            },
            init() {
                this.val = convertAnswerToSliderValue(this.type, this.answer, this.defaultToMax);
            },
        },
        computed: {
            config() {
                return getScorecardItemConfig(this.type);
            },
            answerString(): string | null {
                return convertSliderValueToAnswer(this.type, this.val);
            },
            color(): string {
                return getScorecardItemColor(this.type, this.val);
            },
        },
        props: {
            readonly: Boolean,
            answer: [Number, String],
            type: {
                type: String as () => ScorecardItemType,
                required: true,
            },
            defaultToMax: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            type() {
                this.init();
            },
            answer() {
                this.init();
            },
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
</style>

